import { render, staticRenderFns } from "./HelpRegistration.vue?vue&type=template&id=c4d72ee4&scoped=true"
import script from "./HelpRegistration.vue?vue&type=script&lang=js"
export * from "./HelpRegistration.vue?vue&type=script&lang=js"
import style0 from "./HelpRegistration.vue?vue&type=style&index=0&id=c4d72ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d72ee4",
  null
  
)

export default component.exports